import React from 'react'
import ReportsHeader from '../../../components/HecoReports/ReportHeader/ReportHeader';
import RepXFiles from '../../../components/RepXFiles/RepXFiles';
import { Navigate } from "react-router-dom";

function Files() {
    const companyName = localStorage.getItem("companyName");
    const timestamp = localStorage.getItem("timestamp");
    
  
    return (
      <>
       {/* Generate report if there is a timestamp, otherwise redirects to input form */}
        {timestamp ? (
          <>
            <ReportsHeader defaultType={"Files"} />
            <RepXFiles/>
          </>
        ) : (
          <Navigate to="/inputform" />
        )}
      </>
    );
}

export default Files